import nezhnostCoupleImage from "../../assets/images/templates/nezhnost/couple.avif";
import nezhnostPlaceImage from "../../assets/images/templates/nezhnost/place.avif";
import nezhnostTimerImage from "../../assets/images/templates/nezhnost/timer.avif";

import minimalismCoupleImage from "../../assets/images/templates/minimalism/couple.avif";
import minimalismPlaceImage from "../../assets/images/templates/minimalism/place.avif";
import minimalismTimerImage from "../../assets/images/templates/minimalism/timer.avif";

export const defaultTemplateImages = {
  nezhnostCoupleImage,
  nezhnostPlaceImage,
  nezhnostTimerImage,

  minimalismCoupleImage,
  minimalismPlaceImage,
  minimalismTimerImage,
};
